export const initialState = {
    loader: false,
    wishlist: [],
    productInWIshlist: 0,
    error: ''
}